// extracted by mini-css-extract-plugin
export var h1 = "fallbeispiele-module--h1--3aEgv";
export var headlineWrapper = "fallbeispiele-module--headline-wrapper--2clTJ";
export var spinAround = "fallbeispiele-module--spinAround--2qr6e";